import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

const defaultActivationDate = new Date();
const defaultExpirationDate = new Date();
defaultExpirationDate.setFullYear(defaultExpirationDate.getFullYear() + 10);
export default {
  storeNode: storeStructure.VideoContentVideos,
  title: 'VR Mini Games',
  attributeName:'VR-MiniGames',
  fields: [
    {
      attributeName: 'vreackingBall',
      helpText: 'Vreaking Ball .',
      type: FormInputTypes.CHECKBOX,
      label: 'Vreacking Ball',
      placeholder: 'Video name...',
      default:false
    },
  ],
};
